module.exports = __webpack_public_path__ + "img/home.1e512a32.png";